import { authActions } from "../slices/authSlice";
import request from "../../lib/request";
import { toast } from "react-toastify";
import { OPERATORS_LOGIN, REGISTER_USER } from "../../URLs/Apis";

//Login User
export function loginUser(user) {
  return async (dispatch) => {
    try {
      const res = await request.post(OPERATORS_LOGIN, user);
      console.log(res);
      dispatch(authActions.login(res?.data?.data?.data));
      localStorage.setItem("userInfo", JSON.stringify(res?.data?.data?.data));
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };
}

// logout 
export function logoutUser() {
  return async (dispatch, getState) => {
    try {
      localStorage.clear();
      // localStorage.removeItem("userInfo");
      // localStorage.removeItem("token");
      // localStorage.removeItem("userName");
      dispatch(authActions.logout());
    } catch (error) {
      toast.error(error?.response?.data?.message || "An error occurred");
    }
  };
}

//Register User
export function registerUser(user) {
  return async (dispatch) => {
    try {
      const res = await request.post(REGISTER_USER, user);
      dispatch(authActions.register(res.data));
      localStorage.setItem("userInfo", JSON.stringify(res.data));
    } catch (error) {
      toast.error(error?.response.data.message);
    }
  };
}
